// removed by extract-text-webpack-plugin
module.exports = {"ContactForm__fields":"pu3VqzRUnJgdJqYd1CfRD","ContactForm__title":"_2NBMnWAzQ3O9NOJYCU8jh9","ContactForm__input--name":"_3W7zsoY_bqonQj_DEzThyz","ContactForm__input--email":"_34faJb7XO6FJJRf0hKcDhR","ContactForm__input--message":"_3JroREk3VVrHHa9km-sH3i","ContactForm__buttons":"_1dPXSGbPIuExOuszcAMtKN","ContactForm__button":"_3U-PpgsgyXq-3qqsvkhoVu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ContactUs/ContactUs.scss
// module id = 2709
// module chunks = 0